import {AfterContentChecked, Component, Input, OnInit, inject, DestroyRef} from '@angular/core';
import {RouterSegments} from 'src/app/models/router-segments';
import {Solution} from 'src/app/models/service/solution';
import {AuthService} from 'src/app/services/auth/auth.service';
import {SolutionStatus} from '../../../models/service/solution-status';
import {LineOfBusiness} from 'src/app/models/line-of-business';
import {KeyValueMap} from 'src/app/models/key-value-map';
import {SolutionsService} from 'src/app/services/api/solutions.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-new-solution-card',
    templateUrl: './new-solution-card.component.html',
    styleUrls: ['./new-solution-card.component.scss'],
    standalone: false
})
export class NewSolutionCardComponent implements OnInit, AfterContentChecked {

  @Input() solution: Solution;
  @Input() lineOfBusinessMap: KeyValueMap<string, LineOfBusiness>;
  tenant: string;
  RouterSegments = RouterSegments;
  SolutionStatus = SolutionStatus;
  descriptionData: any;
  lineOfBusinesses: string;
  capabilities: number;
  sortedSolutionVersionId: any;
  private destroyRef = inject(DestroyRef);

  constructor(private authService: AuthService, private solutionsService: SolutionsService) {
  }

  ngOnInit(): void {
    this.tenant = this.authService.principal.provider;
    this.loadData();
  }

  ngAfterContentChecked(): void {
    this.updateLineOfBusinessString();
    this.updateCapabilities();
  }

  loadData(): void {
    const serviceId = this.solution.id;
    this.solutionsService.getSolutionVersions(serviceId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(result => {
        if(result.length > 1) {
          this.solutionsService.getSolutionDetailsById(serviceId)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(latestSolutionDetails => {
            this.solutionsService.getSolutionVersions(serviceId).pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(data => {
            this.sortedSolutionVersionId =
            (data.sort((a,b) => a?.version && b?.version ? b?.version?.localeCompare(a?.version) : !b?.version ? -1 : 1));
            // eslint-disable-next-line max-len
            this.solutionsService.getSolutionVersion(serviceId, (this.sortedSolutionVersionId ? this.sortedSolutionVersionId[0]?.id : latestSolutionDetails?.latestSolutionVersionId))
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(result => {
              if (result.capabilities) {
                this.capabilities = result.capabilities.length;
              }
            });
          });
        });
      } else {
        for (const item of result) {
          if (item.capabilities) {
            this.capabilities = item.capabilities.length;
          }
          this.descriptionData = this.solution.shortDescription;
        }
      }
      });
  }

  private updateLineOfBusinessString(): void {
    if (this.solution && this.lineOfBusinessMap) {
      this.lineOfBusinesses = this.solution.lineOfBusiness
        .map(lineOfBusinessName => this.lineOfBusinessMap[lineOfBusinessName]?.displayName)
        .join(', ');
    } else {
      this.lineOfBusinesses = '';
    }
  }

  private updateCapabilities(): void {
    if (this.solution && this.solution.versions && this.solution.versions[0].capabilities) {
      this.solution.capabilities = this.solution.versions[0].capabilities;
    }
  }
}
